import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-brand-sand" data-id="element-87">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 sm:p-12 text-center relative overflow-hidden" data-id="element-89">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-accent" data-id="element-90"></div>

          <ShieldCheck className="w-16 h-16 text-brand-accent mx-auto mb-6" data-id="element-91" />

          <h2 className="text-2xl sm:text-3xl font-bold text-brand-charcoal mb-6" data-id="element-92">
            GARANTÍA DE 7 DÍAS SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-gray-600 text-lg" data-id="element-93">
            <p className="font-medium text-brand-teal" data-id="element-94">
              Descargalo. Usalo con tus pacientes esta semana.
            </p>
            <p data-id="element-95">
              Si en los primeros 7 días considerás que el Arsenal no cumple lo
              que promete, te devolvemos el 100% del dinero.
            </p>
            <p data-id="element-96">Sin preguntas. Sin formularios. Sin vueltas.</p>
            <p className="font-bold italic text-brand-charcoal pt-4" data-id="element-97">
              Porque estamos seguros de lo que entregamos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}